(function() {
    var case1KeyWord = {
        addMemory:'',
        mainSsdTitle:'SSD Main Slot',
        addSsdTitle:"SSD 2'nd Slot",
        mainSsd:'M.2 2280 NVMe PCIe x 4(NVMe GEN3)',
        addSsd:'M.2 2280 NVMe 또는 SATA',
        supportsItems:[
            '메모리는 ON-BOARD(메인보드에 부착) 형태로, 메모리 업그레이드는 할 수 없습니다.',
            '추가 가능한 SSD 용량 : 256GB, 512GB, 1TB 입니다.',
        ]
    };
    var case2KeyWord = {
        addMemoryTitle:'추가 장착 메모리',
        addSsdTitle:'추가 장착 SSD',
        addMemory:'(SO-DIMM) DDR4-2666Mhz',
        mainSsd:'',
        addSsd:'M.2 2280 NVMe 또는 SATA',
        supportsItems:[
            '추가 메모리 Slot에 8G 장착하여 8G + 8G = 16G(최대) 구성할 수 있습니다.',
            'SSD Slot 2에 추가 장착한 용량은 128GB / 256GB / 512GB 입니다.',
        ]
    };
    var case3KeyWord = {
        addMemoryTitle:'추가 장착 메모리',
        addSsdTitle:'추가 장착 SSD',
        addMemory:'(SO-DIMM) DDR4-3200Mhz',
        mainSsd:'',
        addSsd:'M.2 2280 NVMe 또는 SATA',
        supportsItems:[
            '추가 메모리 Slot에 8GB 또는 16GB 장착하여 8GB + 8GB = 16GB, 8GB + 16GB = 24GB(최대) 구성할 수 있습니다. ',
            'SSD Slot 2에 추가 장착한 용량은 128GB / 256GB / 512GB / 1TB 입니다.',
        ]
    };
    var case4KeyWord = {
        addMemoryTitle:'추가 장착 메모리',
        addSsdTitle:'추가 장착 SSD',
        addMemory:'(SO-DIMM) DDR4-2666Mhz',
        mainSsd:'',
        addSsd:'M.2 2280 NVMe 또는 SATA',
        supportsItems:[
            '추가 메모리 Slot에 4GB 또는 8GB 장착하여 8GB + 4GB = 12GB, 8G + 8G = 16G(최대) 구성할 수 있습니다.',
            'SSD Slot 2에 추가 장착한 용량은 128GB / 256GB / 512GB 입니다. ',
        ]
    };
    var case5KeyWord = {
        addMemoryTitle:'추가 장착 메모리',
        addSsdTitle:'추가 장착 SSD',
        addMemory:'(SO-DIMM) DDR4-2400Mhz',
        mainSsd:'',
        addSsd:'M.2 2280 NVMe 또는 SATA',
        supportsItems:[
            '추가 메모리 Slot에 8G 추가하여 8G + 8G = 16G(최대) 구성 할 수 있습니다.',
            'SSD Slot 2에 추가 장착한 용량은 128GB / 256GB / 512GB 입니다.',
        ]
    };
    var case6KeyWord = {
        addMemoryTitle:'추가 장착 메모리',
        addMemory:'(SO-DIMM) DDR4-2400Mhz',
        mainSsd:'',
        addSsd:'',
        supportsItems:[
            '추가 메모리 Slot에 8G 추가하여 4G + 8G = 12G 구성 할 수 있습니다. 또는 4G 추가하여 4G + 4G = 8G 구성 할 수 있습니다.',
            'SSD 추가 장착이 불가능합니다.',
        ]
    };
    var case7KeyWord = {
        addMemoryTitle:'추가 장착 메모리',
        addSsdTitle:'추가 장착 SSD',
        addMemory:'(SO-DIMM) DDR4-2400Mhz',
        mainSsd:'',
        addSsd:'M.2 2280 NVMe 또는 SATA',
        supportsItems:[
            '추가 메모리 Slot에 8G 추가하여 4G + 8G = 12G 구성 할 수 있습니다. 또는 4G 추가하여 4G + 4G = 8G 구성 할 수 있습니다.',
            'SSD Slot 2에 추가 장착한 용량은 128GB / 256GB / 512GB 입니다.',
        ]
    };
    var case8KeyWord = {
        addMemoryTitle:'추가 장착 메모리',
        addSsdTitle:'추가 장착 SSD',
        addMemory:'(SO-DIMM) DDR4-2400Mhz',
        mainSsd:'',
        addSsd:'M.2 2280 NVMe 또는 SATA',
        supportsItems:[
            '추가 메모리 Slot에 8G 장착하여 8G + 8G = 16G(최대) 구성 할 수 있습니다.',
            'SSD Slot 2에 추가 장착한 용량은 128GB / 256GB / 512GB 입니다.',
        ]
    };
    var case9KeyWord = {
        mainSsdTitle:'SSD Main Slot',
        addSsdTitle:"SSD 2'nd Slot",
        addMemory:'',
        mainSsd:'NVMe M.2 2280 (PCIe 4.0 x 4)',
        addSsd:'NVMe M.2 2280 (PCIe 4.0 x 4)',
        supportsItems:[
            '메모리는 ON-BOARD(메인보드에 부착) 형태로, 메모리 업그레이드는 할 수 없습니다.',
            '추가 가능한 SSD 용량 : 256GB, 512GB, 1TB 입니다.',
        ]
    };
    var case10KeyWord = {
        mainSsdTitle:'SSD Main Slot',
        addSsdTitle:"SSD 2'nd Slot",
        addMemory:'',
        mainSsd:'NVMe M.2 2280 (PCIe 4.0 x 4)',
        addSsd:'NVMe M.2 2280 (PCIe 3.0 x 4)',
        supportsItems:[
            '메모리는 ON-BOARD(메인보드에 부착) 형태로, 메모리 업그레이드는 할 수 없습니다.',
            '추가 가능한 SSD 용량 : 256GB, 512GB, 1TB 입니다.',
        ]
    };
    var keyWords = {
    '17Z95P-G.AA56K':case1KeyWord,
    '17Z95P-G.AA5WK':case1KeyWord,
    '17Z95P-G.AA70K':case1KeyWord,
    '17Z95P-G.AA79K':case1KeyWord,
    '17UD70P-P.AX56K':case1KeyWord,
    '17Z95P-G.AR5BK':case1KeyWord,
    '16Z95P-X.AD70K':case1KeyWord,
    '16Z95P-G.AA56K':case1KeyWord,
    '16Z95P-G.AA79K':case1KeyWord,
    '16Z95P-G.AA7WK':case1KeyWord,
    '16Z95P-G.AA7BK':case1KeyWord,
    '16Z95P-G.AR50K':case1KeyWord,
    '15Z95P-G.AA56K':case1KeyWord,
    '15Z95P-G.AA76K':case1KeyWord,
    '15Z95P-G.AR50K':case1KeyWord,
    '15Z95P-G.AA5WK':case1KeyWord,
    '15Z95P-G.AA5LK':case1KeyWord,
    '15Z95P-G.AA70K':case1KeyWord,
    '15Z95P-G.AA7WK':case1KeyWord,
    '14Z95P-G.ARFWK':case1KeyWord,
    '14Z95P-G.AR5BK':case1KeyWord,
    '14Z95P-G.AR50K':case1KeyWord,
    '14Z95P-G.AA5WK':case1KeyWord,
    '14Z95P-G.AA76K':case1KeyWord,
    '14Z95P-G.AA5LK':case1KeyWord,
    '17Z90P-G.AA50K':case1KeyWord,
    '17Z90P-G.AA5BK':case1KeyWord,
    '17Z90P-G.AA76K':case1KeyWord,
    '17Z90P-G.AA56K':case1KeyWord,
    '17ZD90P-G.AX30K':case1KeyWord,
    '17ZD90P-G.AX7BK':case1KeyWord,
    '16Z90P-G.AA50K':case1KeyWord,
    '16Z90P-G.AA56K':case1KeyWord,
    '16Z90P-G.AA5BK':case1KeyWord,
    '16Z90P-G.AA5IK':case1KeyWord,
    '16Z90P-G.AA5SK':case1KeyWord,
    '16Z90P-G.AA70K':case1KeyWord,
    '16Z90P-G.AA76K':case1KeyWord,
    '16Z90P-G.AA79K':case1KeyWord,
    '16Z90P-G.AA7BK':case1KeyWord,
    '16Z90P-G.AA7IK':case1KeyWord,
    '16Z90P-G.AA7LK':case1KeyWord,
    '16Z90P-G.AA3IK':case1KeyWord,
    '14Z90P-G.AA50K':case1KeyWord,
    '14Z90P-G.AA5BK':case1KeyWord,
    '14Z90P-G.AA76K':case1KeyWord,
    '14Z90P-G.AA56K':case1KeyWord,
    '14Z90P-G.AA5IK':case1KeyWord,
    '14Z90P-G.AA30K':case1KeyWord,
    '14ZD90P-G.AX30K':case1KeyWord,
    '14ZD90P-G.AX70K':case1KeyWord,
    '14ZD90P-G.AX50K':case1KeyWord,
    '14ZD90P-G.AX5BK':case1KeyWord,
    '16T90P-G.AA5BK':case1KeyWord,
    '16T90P-G.AA5SK':case1KeyWord,
    '16T90P-G.AA70K':case1KeyWord,
    '16TD90P-G.AX50K':case1KeyWord,
    '16TD90P-G.AX70K':case1KeyWord,
    '14T90P-G.AA5GK':case1KeyWord,
    '14T90P-G.AA5BK':case1KeyWord,
    '14T90P-G.AA56K':case1KeyWord,
    '14T90P-G.AA70K':case1KeyWord,
    '14TD90P-G.AX30K':case1KeyWord,
    '14TD90P-G.AX50K':case1KeyWord,
    '14TD90P-G.AX70K':case1KeyWord,


    '14Z995-G.AR30K':case2KeyWord,
    '14ZD995-G.AX50K':case2KeyWord,
    '14ZD995-G.AX30K':case2KeyWord,
    '14Z995-G.AR50K':case2KeyWord,
    '14Z995-V.AR3IK':case2KeyWord,
    '14Z995-V.AR5DK':case2KeyWord,
    '14Z995-G.AR3MK':case2KeyWord,
    '15Z995-V.AR50K':case2KeyWord,
    '15ZD995-V.AX50K':case2KeyWord,
    '15Z995-V.AR30K':case2KeyWord,
    '15Z995-V.AA70K':case2KeyWord,
    '15ZD995-V.AX30K':case2KeyWord,
    '15Z995-V.AR5DK':case2KeyWord,
    '15ZD995-V.AX70K':case2KeyWord,
    '15Z995-G.AR5MK':case2KeyWord,
    '15Z995-T.ARIBK':case2KeyWord,
    '17ZD995-V.AX30K':case2KeyWord,
    '17Z995-V.AA50K':case2KeyWord,
    '17Z995-V.AA70K':case2KeyWord,
    '17ZD995-V.AX50K':case2KeyWord,
    '17ZD995-V.AX70K':case2KeyWord,
    '17Z995-V.AA5DK':case2KeyWord,
    '17Z995-G.AA5EK':case2KeyWord,


    '17ZD90N-V.AX70K':case3KeyWord,
    '17ZD90N-V.AX50K':case3KeyWord,
    '17Z90N-V.AA7WK':case3KeyWord,
    '17Z90N-V.AA50K':case3KeyWord,
    '17Z90N-V.AA56K':case3KeyWord,
    '17Z90N-V.AA70K':case3KeyWord,
    '17Z90N-V.AA76K':case3KeyWord,
    '17Z90N-V.AA7BK':case3KeyWord,
    '17ZD90N-V.AX5BK':case3KeyWord,
    '17ZD90N-V.AX7BK':case3KeyWord,
    '17Z90N-V.AA5BK':case3KeyWord,
    '17Z90N-V.AA79K':case3KeyWord,
    '17Z90N-V.AA7IK':case3KeyWord,
    '17Z90N-V.AA7YK':case3KeyWord,
    '15ZD90N-V.AX7BK':case3KeyWord,
    '15Z90N-V.AR5IK':case3KeyWord,
    '15Z90N-V.AR5BK':case3KeyWord,
    '15Z90N-V.AR50K':case3KeyWord,
    '15Z90N-V.AA7BK':case3KeyWord,
    '15Z90N-V.AA79K':case3KeyWord,
    '15Z90N-V.AA70K':case3KeyWord,
    '15Z90N-H.AR56K':case3KeyWord,
    '15Z90N-H.AA76K':case3KeyWord,
    '15ZD90N-V.AX5BK':case3KeyWord,
    '15ZD90N-V.AX50K':case3KeyWord,
    '15Z90N-V.AR30K':case3KeyWord,
    '15ZD90N-H.AX56K':case3KeyWord,
    '15ZD90N-V.AX70K':case3KeyWord,
    '15Z90N-V.AR56K':case3KeyWord,
    '15Z90N-V.AR36K':case3KeyWord,
    '15Z90N-V.AA7IK':case3KeyWord,
    '15Z90N-V.AR3IK':case3KeyWord,
    '15Z90N-V.AR3SK':case3KeyWord,
    '15Z90N-V.AR5SK':case3KeyWord,
    '15Z90N-V.AR3YK':case3KeyWord,
    '14Z90N-V.AA76K':case3KeyWord,
    '14Z90N-V.AR30K':case3KeyWord,
    '14Z90N-VR36K':case3KeyWord,
    '14Z90N-V.AR50K':case3KeyWord,
    '14Z90N-V.AR56K':case3KeyWord,
    '14ZD90N-V.AX30K':case3KeyWord,
    '14ZD90N-V.AX50K':case3KeyWord,
    '14ZD90N-V.AX5BK':case3KeyWord,
    '14ZD90N-V.AX70K':case3KeyWord,
    '14Z90N-V.AR5IK':case3KeyWord,


    '14T90N-V.AA70K':case4KeyWord,
    '14T90N-V.AR30K':case4KeyWord,
    '14T90N-V.AR50K':case4KeyWord,
    '14T90N-V.AR56K':case4KeyWord,
    '14TD90N-V.AX30K':case4KeyWord,
    '14TD90N-V.AX50K':case4KeyWord,
    '14TD90N-V.AX70K':case4KeyWord,


    '14ZD990-G.AX5BK':case5KeyWord,
    '14ZD990-G.AX50K':case5KeyWord,
    '14Z990-G.AA70K':case5KeyWord,
    '14Z990-G.AA56K':case5KeyWord,
    '14Z990-G.AA50K':case5KeyWord,
    '14ZD990-G.AX70K':case5KeyWord,
    '14ZD990-G.AX7BK':case5KeyWord,
    '14Z990-G.AA5IK':case5KeyWord,
    '14Z990-G.AA5EK':case5KeyWord,
    '14Z990-G.AR5TK':case5KeyWord,
    '14Z990-G.AR5DK':case5KeyWord,
    '14Z990-GR3SK':case5KeyWord,
    '14Z990-G.AR3DK':case5KeyWord,
    '15Z990-H.AA76K':case5KeyWord,
    '15Z990-V.AA5BK':case5KeyWord,
    '15ZD990-H.AX56K':case5KeyWord,
    '15ZD990-V.AX50K':case5KeyWord,
    '15ZD990-V.AX5BK':case5KeyWord,
    '15ZD990-V.AX70K':case5KeyWord,
    '15ZD990-V.AX7BK':case5KeyWord,
    '15Z990-V.AA7IK':case5KeyWord,
    '15Z990-V.AA5WK':case5KeyWord,
    '15Z990-V.AA5SK':case5KeyWord,
    '15Z990-V.AA5IK':case5KeyWord,
    '15Z990-V.AR5DK':case5KeyWord,
    '15Z990-G.AR3MK':case5KeyWord,
    '15Z990-V.AR5DK':case5KeyWord,
    '15Z990-V.AR5TK':case5KeyWord,
    '15Z990-V.AA7TK':case5KeyWord,
    '15Z990-G.AR3DK':case5KeyWord,
    '15Z990-T.ARIBK':case5KeyWord,
    '17Z990-V.AA5IK':case5KeyWord,
    '17Z990-V.AA56K':case5KeyWord,
    '17Z990-V.AA76K':case5KeyWord,
    '17Z990-V.AA5BK':case5KeyWord,
    '17Z990-V.AA50K':case5KeyWord,
    '17Z990-V.AA70K':case5KeyWord,
    '17Z990-V.AA7BK':case5KeyWord,
    '17ZD990-V.AX50K':case5KeyWord,
    '17ZD990-V.AX5BK':case5KeyWord,
    '17ZD990-V.AX70K':case5KeyWord,
    '17ZD990-V.AX7BK':case5KeyWord,
    '17Z990-V.AA79K':case5KeyWord,
    '17Z990-V.AA5NK':case5KeyWord,
    '17Z990-V.AA5DK':case5KeyWord,
    '17Z990-V.AA7TK':case5KeyWord,


    '14ZD990-L.AX10K':case6KeyWord,
    '14Z990-L.AR1MK':case6KeyWord,
    '14Z990-L.AR10K':case6KeyWord,
    '14Z990-L.AR2MK':case6KeyWord,
    '15ZD990-L.AX10K':case6KeyWord,
    '15Z990-L.AR10K':case6KeyWord,
    '15Z990-L.AR1DK':case6KeyWord,
    '15Z990-L.AR2DK':case6KeyWord,


    '14ZD990-G.AX30K':case7KeyWord,
    '14Z990-G.AA36K':case7KeyWord,
    '14Z990-G.AA3HK':case7KeyWord,
    '14Z990-G.AR30K':case7KeyWord,
    '14Z990-G.AR36K':case7KeyWord,
    '14Z990-G.AR3IK':case7KeyWord,
    '15Z990-G.AA30K':case7KeyWord,
    '15Z990-G.AA36K':case7KeyWord,
    '15Z990-G.AR30K':case7KeyWord,
    '15ZD990-G.AX30K':case7KeyWord,
    '15Z990-G.AR3IK':case7KeyWord,
    '15Z990-G.AR3SK':case7KeyWord,
    '17Z990-G.AA3MK':case7KeyWord,
    '17Z990-G.AA30K':case7KeyWord,
    '17ZD990-G.AX30K':case7KeyWord,
    '17Z990-G.AA3AK':case7KeyWord,


    '14T990-G.AA30K':case8KeyWord,
    '14T990-G.AA50K':case8KeyWord,
    '14T990-G.AA56K':case8KeyWord,
    '14T990-G.AA5BK':case8KeyWord,
    '14T990-G.AA5IK':case8KeyWord,
    '14T990-G.AA70K':case8KeyWord,
    '14T990-G.AA36K':case8KeyWord,
    '14TD990-G.AX70K':case8KeyWord,
    '14TD990-G.AX50K':case8KeyWord,
    '14TD990-G.AX30K':case8KeyWord,


'17Z90Q-G.AD79K':case9KeyWord,
'17Z90Q-G.AA7WK':case9KeyWord,
'17Z90Q-G.AA76K':case9KeyWord,
'17Z90Q-G.AA7BK':case9KeyWord,
'17Z90Q-G.AA70K':case9KeyWord,
'17Z90Q-G.AA5WK':case9KeyWord,
'17Z90Q-G.AA56K':case9KeyWord,
'17Z90Q-G.AA5LK':case9KeyWord,
'17Z90Q-G.AR5JK':case9KeyWord,
'17Z90Q-G.AR5KK':case9KeyWord,
'17Z90Q-G.AR5BK':case9KeyWord,
'17Z90Q-G.AR5CK':case9KeyWord,
'17Z90Q-G.AR50K':case9KeyWord,
'17ZD90Q-G.AX7BK':case9KeyWord,
'17ZD90Q-G.AX76K':case9KeyWord,
'17ZD90Q-G.AX5LK':case9KeyWord,
'17ZD90Q-G.AX56K':case9KeyWord,
'17ZD90Q-G.AX50K':case9KeyWord,
'16Z90Q-G.AD79K':case9KeyWord,
'16Z90Q-G.AA7WK':case9KeyWord,
'16Z90Q-G.AA76K':case9KeyWord,
'16Z90Q-G.AA7BK':case9KeyWord,
'16Z90Q-G.AA70K':case9KeyWord,
'16Z90Q-G.AA5LK':case9KeyWord,
'16Z90Q-G.AA5UK':case9KeyWord,
'16Z90Q-G.AA5WK':case9KeyWord,
'16Z90Q-G.AA56K':case9KeyWord,
'16Z90Q-G.AR5JK':case9KeyWord,
'16Z90Q-G.AR5KK':case9KeyWord,
'16Z90Q-G.AR5BK':case9KeyWord,
'16Z90Q-G.AA5CK':case9KeyWord,
'16Z90Q-G.AR5CK':case9KeyWord,
'16Z90Q-G.AR50K':case9KeyWord,
'16ZD90Q-G.AX76K':case9KeyWord,
'16ZD90Q-G.AX5LK':case9KeyWord,
'16ZD90Q-G.AX56K':case9KeyWord,
'16ZD90Q-G.AX50K':case9KeyWord,
'16ZD90Q-G.AX36K':case9KeyWord,
'16ZD90Q-G.AX30K':case9KeyWord,
'16ZD90Q-G.AX5BK':case9KeyWord,
'15Z90Q-G.AA7WK':case9KeyWord,
'15Z90Q-G.AA76K':case9KeyWord,
'15Z90Q-G.AA70K':case9KeyWord,
'15Z90Q-G.AA5LK':case9KeyWord,
'15Z90Q-G.AA5WK':case9KeyWord,
'15Z90Q-G.AA56K':case9KeyWord,
'15Z90Q-G.AR50K':case9KeyWord,
'15ZD90Q-G.AX76K':case9KeyWord,
'15ZD90Q-G.AX5LK':case9KeyWord,
'15ZD90Q-G.AX56K':case9KeyWord,
'15ZD90Q-G.AX5BK':case9KeyWord,
'15ZD90Q-G.AX50K':case9KeyWord,
'15ZD90Q-G.AX36K':case9KeyWord,
'15ZD90Q-G.AX30K':case9KeyWord,
'14Z90Q-G.AA76K':case9KeyWord,
'14Z90Q-G.AA56K':case9KeyWord,
'14Z90Q-G.AA5LK':case9KeyWord,
'14Z90Q-G.AA5WK':case9KeyWord,
'14Z90Q-G.AA5CK':case9KeyWord,
'14Z90Q-G.AR5IK':case9KeyWord,
'14Z90Q-G.AR50K':case9KeyWord,
'14Z90Q-G.AR5BK':case9KeyWord,
'14Z90Q-G.AR30K':case9KeyWord,
'14ZD90Q-G.AX70K':case9KeyWord,
'14ZD90Q-G.AX56K':case9KeyWord,
'14ZD90Q-G.AX50K':case9KeyWord,
'14ZD90Q-G.AX5BK':case9KeyWord,
'14ZD90Q-G.AX30K':case9KeyWord,
'16T90Q-G.AA79K':case9KeyWord,
'16T90Q-G.AA70K':case9KeyWord,
'16T90Q-G.AA7BK':case9KeyWord,
'16T90Q-G.AA5UK':case9KeyWord,
'16T90Q-G.AA56K':case9KeyWord,
'16T90P-G.AA5GK':case9KeyWord,
'16T90Q-G.AR5BK':case9KeyWord,
'16T90Q-G.AR5SK':case9KeyWord,
'16TD90Q-G.AX70K':case9KeyWord,
'16TD90Q-G.AX56K':case9KeyWord,
'16TD90Q-G.AX50K':case9KeyWord,
'14T90Q-G.AA79K':case9KeyWord,
'14T90Q-G.AA70K':case9KeyWord,
'14T90Q-G.AA7BK':case9KeyWord,
'14T90Q-G.AA5PK':case9KeyWord,
'14T90Q-G.AR5PK':case9KeyWord,
'14T90Q-G.AR5GK':case9KeyWord,
'14T90Q-G.AR5BK':case9KeyWord,
'14T90Q-G.AA56K':case9KeyWord,
'14TD90Q-G.AX7GK':case9KeyWord,
'14TD90Q-G.AX5PK':case9KeyWord,
'14TD90Q-G.AX5GK':case9KeyWord,
'14TD90Q-G.AX5BK':case9KeyWord,

'17Z90Q-E.AA7WK':case10KeyWord,
'17Z90Q-S.AA7WK':case10KeyWord,
'17Z90Q-E.AA76K':case10KeyWord,
'17Z90Q-S.AA76K':case10KeyWord,
'17Z90Q-E.AA5WK':case10KeyWord,
'17Z90Q-S.AA5WK':case10KeyWord,
'17Z90Q-E.AA5JK':case10KeyWord,
'17Z90Q-E.AR50K':case10KeyWord,
'17Z90Q-S.AR50K':case10KeyWord,
'17ZD90Q-E.AX76K':case10KeyWord,
'17ZD90Q-S.AX76K':case10KeyWord,
'17ZD90Q-E.AX56K':case10KeyWord,
'17ZD90Q-S.AX56K':case10KeyWord,
'16Z90Q-E.AD79K':case10KeyWord,
'16Z90Q-E.AA7WK':case10KeyWord,
'16Z90Q-S.AA7WK':case10KeyWord,
'16Z90Q-E.AA76K':case10KeyWord,
'16Z90Q-S.AA76K':case10KeyWord,
'16Z90Q-E.AA5HK':case10KeyWord,
'16Z90Q-E.AA5MK':case10KeyWord,
'16Z90Q-E.AA5WK':case10KeyWord,
'16Z90Q-S.AA5WK':case10KeyWord,
'16Z90Q-E.AA5JK':case10KeyWord,
'16Z90Q-E.AR50K':case10KeyWord,
'16Z90Q-S.AR50K':case10KeyWord,
'16ZD90Q-E.AX76K':case10KeyWord,
'16ZD90Q-S.AX76K':case10KeyWord,
'16ZD90Q-E.AX56K':case10KeyWord,
'16ZD90Q-S.AX56K':case10KeyWord,
'16ZD90Q-E.AX50K':case10KeyWord,
'16ZD90Q-S.AX50K':case10KeyWord,
    }
    var MKTF30091_tmpl = 
    '<div class="standard-slot">'+
        '<p class="tit">규격 및 장착 슬롯</p>'+
        '<hr>'+
        '<dl>'+
            '{{#each item, index in gramUpgradeInfo.optionTitle}}'+
                '<div class="item">'+
                    '<dt>{{item}}</dt>'+
                    '<dd>{{gramUpgradeInfo.optionDesc[index]}}</dd>'+
                '</div>'+
            '{{/each}}'+
        '</dl>'+
    '</div>'+
    '<div class="apply-volume">'+
        '<p class="tit">지원 용량</p>'+
        '<hr>'+
        '<ul class="list">'+
        '{{#each item in gramUpgradeInfo.supportCapacityDesc}}'+
            '<li>'+
                '{{item}}'+
            '</li>'+
        '{{/each}}'+
        '</ul>'+
    '</div>';

    var gramGuideTmpl =
    '{{#each item in gramGuideList}}'+
    '<li>'+
        '<a href="{{item.guideId}}" target="_blank" data-contents="{{item.title}}">'+
            '<img src="{{item.moListThumbnailPath}}" data-pc-src="{{item.pcListThumbnailPath}}" data-m-src="{{item.moListThumbnailPath}}" alt="{{vcui.detect.isMobile ? item.moListThumbnailAltText : item.pcListThumbnailAltText}}">'+
        '</a>'+
    '</li>'+
    '{{/each}}';

	var MKTF30091 = {
        fullUrl: {
            'www.lge.co.kr':'https://www.lge.co.kr/',
            'wwwstg.lge.co.kr':'https://wwwstg.lge.co.kr/',
            'brandstg.lge.co.kr':'https://wwwstg.lge.co.kr/',
            'wwwdev50.lge.co.kr':'https://wwwdev50.lge.co.kr/',
            'branddev.lge.co.kr':'https://wwwdev50.lge.co.kr/',
            'localhost':'/',
            'brand.lge.co.kr':'https://www.lge.co.kr/',
        },
        publUrl:{
            gramGuideListUrl: '/lg5-common/data-ajax/gram/retrieveGramGuideList.json',
            gramGuideInfoUrl: '/lg5-common/data-ajax/gram/retrieveGramUpgradeInfo.json',
            upgradeUrl :'/html/GRC/MKTF30092.html?guideId=',  
        },
        url:{
            gramGuideListUrl: '/mkt/api/gram/retrieveGramGuideList.lgajax',
            gramGuideInfoUrl: '/mkt/api/gram/retrieveGramUpgradeInfo.lgajax',
            upgradeUrl :'/gram/upgrade-guide?guideId=',
        },
        isSearchResult:false,
		init: function(){
			var self = this;
            self.$el = $('.MKTF30091');	
            self.$addTmpl = self.$el.find('.srch-result .info-wrap');	
            self.$input = self.$el.find('.srch .input-wrap input');	
            self.$inputBtn = self.$el.find('.srch .input-wrap .btn-srch');	
            self.$gramGuideList = self.$el.find('.add-content ul');
            self.setSearchResult(false);
			self.bindEvents();
            self.$input.addClass('ui_input_clearbutton')
            .attr('data-clear-button','button.btn-delete')
            .attr('data-autofocus','true')
            .attr('ui-modules','inputClearButton');
     
            //그램을 더욱 그램답게 서비스 알아보기
            var fullUrl = self.getFullUrl();
            var $btn0 = $('.new-gram-service li').eq(0).find('a');
            var $btn1 = $('.new-gram-service li').eq(1).find('a');
            var href0 = fullUrl + $btn0.attr('href').replace('https://www.lge.co.kr/','');
            var href1 = fullUrl + $btn1.attr('href').replace('https://www.lge.co.kr/','');
            $btn0.attr('href',href0);
            $btn1.attr('href',href1);

            //무엇이든 물어보세요 그램상담소
            self.requestData(self.getUrl().gramGuideListUrl, {guideType:'01'}, function (result) {
                var data = result.data[0];
                if(data.gramGuideList){
                    if(data.gramGuideList.length > 0){
                        lists = vcui.template(gramGuideTmpl, data);
                        self.$gramGuideList.html(lists);

                        if(self.$gramGuideList.vcLazyLoaderSwitch){
                            self.$gramGuideList.vcLazyLoaderSwitch();
                        }else{
                            vcui.require([
                                'ui/lazyLoaderSwitch',
                            ], function () {
                                self.$gramGuideList.vcLazyLoaderSwitch();
                            });
                        }

                        self.$el.find('.add-content').css('visibility','visible');
                        return;
                    }
                }
                self.$el.find('.add-content').hide()
            });
		},
        requestData: function (_json, _post, _func) {
            var self = this;
            var ajaxUrl = _json;
            var postData = _post;
            lgkorUI.requestAjaxDataPost(ajaxUrl, postData, function (result) {
                _func(result);
            });
        },
        getFullUrl: function () {
            var self = this;
            var href = window.location.href;
            var fullUrl;
            for(var key in self.fullUrl){
                if(href.indexOf(key)>-1){
                    fullUrl = self.fullUrl[key]
                }
            }
            return fullUrl;
        },
        setSearchResult : function(_is){
            var self = this;
            self.isSearchResult = _is || false;
            if(self.isSearchResult){
                self.$el.find('.srch-guide').hide();
                self.$el.find('.info-wrap').css('display','flex')
            }else{
                self.$el.find('.srch-guide').show();
                self.$el.find('.info-wrap').css('display','none')
            }
        },
		bindEvents: function() {
			var self = this;
            $('[data-href]').on('click', function(e){
                e.preventDefault();
                window.location.href =  $(this).attr('data-href');
             });
            //제품 키워드 검색
            self.$inputBtn.on('click', function(e){
				e.preventDefault();
                self.$input.blur();  // BTOCSITE-60770
                var searchText = self.$input.val().trim();
                searchText = searchText.toUpperCase();
                if(searchText===''){
                    self.noKeyword(searchText);
                    return;
                }
                self.requestData(self.getUrl().gramGuideInfoUrl, {'modelCode':searchText}, function (result) {
                    if(result.dataCount == 0){return;}
                    var data = result.data[0];
                    if(data.gramUpgradeInfo){
                        //console.log('제품 키워드 있음');
                        data.gramUpgradeInfo.optionTitle = [];
                        data.gramUpgradeInfo.optionDesc = [];
                        data.gramUpgradeInfo.supportCapacityDesc = [];
                        for(var key in data.gramUpgradeInfo){
                            if( key.indexOf('supportCapacityDesc') >-1 && key.length != 'supportCapacityDesc'.length){
                                'supportCapacityDesc'.length == 
                                data.gramUpgradeInfo.supportCapacityDesc.push(data.gramUpgradeInfo[key])
                            }
                            if( key.indexOf('optionTitle') >-1 && key.length != 'optionTitle'.length){
                                
                                data.gramUpgradeInfo.optionTitle.push(data.gramUpgradeInfo[key])

                            }
                            if( key.indexOf('optionDesc') >-1 && key.length != 'optionDesc'.length){
                                data.gramUpgradeInfo.optionDesc.push(data.gramUpgradeInfo[key])
                            }
                        }
                        self.setSearchResult(true);
                        void 0;
                        var lists = vcui.template(MKTF30091_tmpl, data);
                        self.$addTmpl.html(lists);
                    }else{
                        self.noKeyword(searchText);
                    }
                });
			});
            self.$input.keydown('keydown',function(e) {
                if(e.keyCode == 13){
                    self.$inputBtn.trigger('click');
                }
            })
            //유의사항 토글
            self.$el.on('click', '.srch-result .note button', function(e){
				e.preventDefault();
                $(this).parent().parent().toggleClass('on');
			});
            //그램상담소 배너링크
            self.$el.on('click', '.add-content li a', function(e){
				e.preventDefault();
                var id = $(this).attr('href');
                window.location.href=self.getUrl().upgradeUrl + id;
			});

		},
        //제품 키워드 없음
        noKeyword:function(_searchText){
            var self = this;
            var id =  self.$inputBtn.data('id');
            var obj ={title:'.', ok : function (){ self.$input.focus();}};
            var desc = '';
            if(id=="#srch"){ 
                obj = $.extend(obj,{title : _searchText ? '입력하신 키워드와 일치하는<br>모델명이 없습니다.':'제품 모델명을 입력해 주세요.'});
                desc = '';
            }    
            lgkorUI.alert(desc, obj);
            self.setSearchResult(false);
        },
        getUrl : function(){
            var self = this;
            if(window.location.href.indexOf('localhost') > -1 || window.location.href.indexOf('wwwdev50') > -1){
                return self.publUrl;
            }else{
                return self.url;
            }
        },
        requestData: function(_json, _post, _func) {
            var self = this;
            var ajaxUrl = _json;
            var postData = _post;
            lgkorUI.requestAjaxDataPost(ajaxUrl, postData, function(result){
                _func(result);
            });
        },
	};
	$(document).ready(function(){
		if(!document.querySelector('.MKTF30091')) return false;
		$('.MKTF30091').buildCommonUI();
		MKTF30091.init();
	});
})();